import { createContextualCan } from "@casl/react";
import { createContext } from "react";
export const AbilityContext = createContext<any>(undefined);
export const Can = createContextualCan(AbilityContext.Consumer);
